module.exports = __webpack_public_path__ + "static/img/longfei8.f9a6e94.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/longfei8.png
// module id = fbZX
// module chunks = 1